import React from "react"

import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Application } from "@/contexts/ApplicationContext"

interface NextOfKinSectionProps {
  application: Application
  setApplication: React.Dispatch<React.SetStateAction<Application>>
}

const NextOfKinSection: React.FC<NextOfKinSectionProps> = ({ application, setApplication }) => {
  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, "") // Remove non-digits
    if (value.length <= 15) {
      // Max 15 digits for international numbers
      setApplication((prev) => ({
        ...prev,
        personalDetails: {
          ...prev.personalDetails,
          nextOfKin: {
            ...prev.personalDetails.nextOfKin,
            phone: value,
          },
        },
      }))
    }
  }

  return (
    <div className="space-y-4">
      <h2 className="mb-4 text-xl font-bold">Next of Kin Details</h2>

      <div className="space-y-2">
        <Label htmlFor="nextOfKinName">Name</Label>
        <Input
          id="nextOfKinName"
          value={application.personalDetails.nextOfKin.name}
          onChange={(e) =>
            setApplication((prev) => ({
              ...prev,
              personalDetails: {
                ...prev.personalDetails,
                nextOfKin: {
                  ...prev.personalDetails.nextOfKin,
                  name: e.target.value,
                },
              },
            }))
          }
          placeholder="Enter next of kin name"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="nextOfKinPhone">Phone Number</Label>
        <Input
          id="nextOfKinPhone"
          type="tel"
          value={application.personalDetails.nextOfKin.phone}
          onChange={handlePhoneChange}
          placeholder="Enter next of kin phone number"
          minLength={10}
          maxLength={15}
        />
        <p className="text-sm text-gray-500">Phone number should be 10-15 digits</p>
      </div>

      <div className="space-y-2">
        <Label htmlFor="nextOfKinRelation">Relationship</Label>
        <Input
          id="nextOfKinRelation"
          value={application.personalDetails.nextOfKin.relation}
          onChange={(e) =>
            setApplication((prev) => ({
              ...prev,
              personalDetails: {
                ...prev.personalDetails,
                nextOfKin: {
                  ...prev.personalDetails.nextOfKin,
                  relation: e.target.value,
                },
              },
            }))
          }
          placeholder="E.g. Spouse, Parent, Sibling"
        />
      </div>
    </div>
  )
}

export default NextOfKinSection
